import { Indicator, Toast } from 'mint-ui'

import qs from 'qs'

var axios = require('axios');


var config = require('../../config'),
    host = '';
if('"'+process.env.NODE_ENV+'"' == config.dev.env.NODE_ENV){
    // host = 'http://demo.magapp-x.magcloud.cc/';
    // host = 'http://app.lxh.magcloud.cc/';
    host = 'http://magapp-x.net/';
}else{
  host = window.location.origin;
}
var http = axios.create({
    baseURL: host,
    //timeout: 20000,
});

export default {
    get (api, params, success, fail){
        if(typeof params.needLoadingIndicator === 'undefined'){
          params.needLoadingIndicator = true;
        }
        if(params.needLoadingIndicator){
          Indicator.open();
        }
        http.get(api, {
            params: params
        }).then(function (response) {
            if(params.needLoadingIndicator){
              setTimeout(function(){
                  Indicator.close();
              }, 500);
            }
            if(success){
                success(response.data);
            }
        }).catch(function (error) {
            Indicator.close();
            //Toast('网络出错了');
            if (error.message === 'Network Error') {
              //网络错误处理
            }
            if(fail){
                fail(error);
            }
        });
    },

    post (api, params, callback, fail){
        if(typeof params.needLoadingIndicator === 'undefined'){
          params.needLoadingIndicator = true;
        }
        if(params.needLoadingIndicator){
          Indicator.open();
        }
        http.post(api, qs.stringify(params), {
              headers: {
                  'Content-Type': 'application/x-www-form-urlencoded'
              }
          }).then(function (response) {
            Indicator.close();
            if(callback){
              callback(response.data);
            }
          })
          .catch(function (error) {
            Indicator.close();
            Toast(error);
            if(fail){
                fail(error);
            }
          });
    }
}



// WEBPACK FOOTER //
// ./src/common/http.js